<template>
  <div
    class="vadStepschronological is-margin-bottom-xxsmall is-border"
    style="border-radius: 0">
    <!-- DONNES RESERVANT -->
    <div
      style="justify-content: flex-start ; align-items: center; min-height: 80px; min-width: 25%"
      class="vadStepschronological-item">
      <div
        style="margin-top: 0px; border-top: 0"
        class="vadStepschronological-item-visuel"
        :class="localCurrentStep <= 1 ? 'progressBarFirst50' : 'progressBarFirst50 progressBarLast50'">
        <div
          :style="localCurrentStep >= 2 ? 'background-color: #80BB73 ' : ''"
          style="position: absolute; color: white; left: 50%; width: 37px; height: 37px; z-index: 1">
          <span class="icon is-large is-size-1"><i class="fas fa-check-circle"></i></span>
        </div>
      </div>
      <div
        style="padding: none; padding-top: 2.7rem; text-align: center"
        class="vadStepschronological-item-info">
        <span
          style="font-size: 1rem"
          class="has-text-weight-medium is-uppercase">Données Réservant(s)</span>
        <br>
        <a
          v-if="localCurrentStep > 1"
          @click="localCurrentStep = 1 ;modifyStep()"
          style="font-size: 1rem"
          class="has-text-weight-light">(<span class="is-underline is-italic">Modifier</span>)</a>
      </div>
    </div>
    <!-- PRIX -->
    <div
      style="justify-content: flex-start ; align-items: center; min-height: 80px; min-width: 25%"
      class="vadStepschronological-item">
      <div
        style="margin-top: 0px; border-top: 0"
        class="vadStepschronological-item-visuel"
        :class="{'progressBarFirst50': localCurrentStep >= 2, 'progressBarLast50': localCurrentStep > 2}">
        <div
          :style="localCurrentStep >= 3 ? 'background-color: #80BB73;' : ''"
          style="color: white; width: 37px; height: 37px; z-index: 1">
          <span class="icon is-large is-size-1"><i class="fas fa-check-circle"></i></span>
        </div>
      </div>
      <div
        style="padding: none; padding-top: 2.7rem; text-align: center"
        class="vadStepschronological-item-info">
        <span
          style="font-size: 1rem"
          class="has-text-weight-medium is-uppercase">Prix</span>
        <br>
        <a
          v-if="localCurrentStep > 2"
          @click="localCurrentStep = 2; modifyStep()"
          style="font-size: 1rem"
          class="has-text-weight-light">(<span class="is-underline is-italic">Modifier</span>)</a>
      </div>
    </div>
    <!-- FINANCEMENT -->
    <div
      style="justify-content: flex-start ; align-items: center; min-height: 80px; min-width: 25%"
      class="vadStepschronological-item">
      <div
        style="margin-top: 0px; border-top: 0"
        class="vadStepschronological-item-visuel"
        :class="{'progressBarFirst50': localCurrentStep >= 3, 'progressBarLast50': localCurrentStep > 3}">
        <div
          :style="localCurrentStep === 4 ? 'background-color: #80BB73;' : ''"
          style="color: white; width: 37px; height: 37px; z-index: 1">
          <span class="icon is-large is-size-1"><i class="fas fa-check-circle"></i></span>
        </div>
      </div>
      <div
        style="padding: none; padding-top: 2.7rem; text-align: center"
        class="vadStepschronological-item-info">
        <span
          style="font-size: 1rem"
          class="has-text-weight-medium is-uppercase">Financement</span>
        <br>
        <a
          v-if="localCurrentStep > 3"
          @click="localCurrentStep = 3; modifyStep()"
          style="font-size: 1rem"
          class="has-text-weight-light">(<span class="is-underline is-italic">Modifier</span>)</a>
      </div>
    </div>
    <!-- VALIDATION -->
    <div
      style="justify-content: flex-start ; align-items: center; min-height: 80px; min-width: 25%"
      class="vadStepschronological-item">
      <div
        style="margin-top: 0px; border-top: 0"
        class="vadStepschronological-item-visuel"
        :class="localCurrentStep === 4 ? 'progressBarFirst50' : ''">
        <div
          style="color: white; left: 50%; width: 37px; height: 37px; z-index: 1">
          <span class="icon is-large is-size-1"><i class="fas fa-check-circle"></i></span>
        </div>
      </div>
      <div
        style="padding: none; padding-top: 2.7rem; text-align: center"
        class="vadStepschronological-item-info">
        <span
          style="font-size: 1rem"
          class="has-text-weight-medium is-4 is-uppercase">Validation</span>
      </div>
    </div>
  </div>
</template>

<script>
import { DefaultValues } from '@/mixins'

export default {
  name: 'ValidationPreResa',
  mixins: [DefaultValues],
  props: {
    currentStep: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      localCurrentStep: this.currentStep
    }
  },
  computed: {
    isPending () {
      return this.reservation.status === 'pending'
    }
  },
  watch: {
    currentStep (newValue) {
      this.localCurrentStep = newValue
    }
  },
  methods: {
    modifyStep () {
      this.$emit('update:currentStep', this.localCurrentStep)
    }
  }
}
</script>

<style scoped>
.progressBarFirst50::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 50%; /* Contrôle la longueur de la barre de progression */
    height: 100%;
    background-color: #80BB73; /* La couleur de la barre de progression */
    border-radius: 0;
}

.progressBarLast50::after {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    width: 50%; /* Contrôle la longueur de la barre de progression */
    height: 100%;
    background-color: #80BB73; /* La couleur de la barre de progression */
    border-radius: 0;
}
</style>
